// extracted by mini-css-extract-plugin
export default {"layourWrapper":"Layout_layourWrapper__v1NHZ"};